import { ApiService } from '../../app-lite/api/api.service';

import ScheduleHtml from './schedule.html';

import moment from 'moment';

export function ScheduleStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'ScheduleCtrl',
    name       : 'app.schedule',
    templateUrl: ScheduleHtml,
    url        : '/schedule',
    resolve    : {
      groups  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/mechanic_grouping_for_filter', '10'),
      schedule: ( dateParsing, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.post('/schedule/show', {
        include_default: true,
        start_date     : moment(dateParsing.weekRangeStart()).add(1, 'days').format('YYYY-MM-DD')
      })
    }
  });
}